import { useContext, createContext } from 'react';

type BrandColorType = {
	brandColor: string;
	setBrandColor: (name: string) => void;
};
export const BrandColorContext = createContext<BrandColorType | undefined>(undefined);

export const useBrandColor = (): BrandColorType | undefined => useContext(BrandColorContext);
